
















































































//import {functions,firestore} from "@/scripts/firebase";
import { ClassData, NoticeProps, UserPublicProfile } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'

//import { User } from 'firebase';
//import { StringOrNumber } from 'vee-validate/dist/types/types';
import Notice from '@/components/Notice.vue';
import PanelSelectUser from '@/components/PanelSelectUser.vue';


@Component({
  components: {
    Notice,
    PanelSelectUser
  }
})


export default class AddClass extends Mixins(Common) {
  notice = {} as NoticeProps
  defaultClassData: ClassData = {
    teacherUids: undefined,
    studentUids: undefined,
    name: '',
    description: '',
    memberUids: undefined,
    disabled: false,
    deleted: false,
    memberMeta: {}
  }
  tIsShow = false
  sIsShow = false
  theClass = {...this.defaultClassData}
  isLoading = false

  $refs!: {
    teachers: InstanceType<typeof ValidationProvider>;
    students: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get disabledAddClass(){
    return this.theClass.name === '' || ! this.theClass.studentUids || this.theClass.studentUids.length === 0  || ! this.theClass.teacherUids || this.theClass.teacherUids.length === 0
  }

  get teacherUids(){
    if(Array.isArray(this.theClass.teacherUids)){
      this.$refs.teachers.validate()
    }
    return this.theClass.teacherUids
  }

  get studentUids(){
    if(Array.isArray(this.theClass.studentUids)){
      this.$refs.students.validate()
    }
    
    return this.theClass.studentUids
  }

  onSelect(type: 'teacher' | 'student', event: false | UserPublicProfile){
    if(event === false){
      if(type === 'teacher'){
        this.tIsShow = false
      }
      if(type === 'student'){
        this.sIsShow = false
      }
      return
    }
    this.toggleClassMember(event,type)
  }

  async addClass(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: ClassData = {
          ...this.theClass
        }

        const ClassDocRef = await this.$createDoc(this.$getClassesColRef(),data)
        
        await this.$waitUntilUpdatedForDoc(ClassDocRef)

        this.notice = {
          message: this.$t('addClass.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theClass = {...this.defaultClassData}

        this.$refs.validationObserver.reset()
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addClass.error') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  toggleClassMember(user: string | UserPublicProfile, type: 'student' | 'teacher'){

    const theUid = (typeof user === 'string') ? user : user.uid || ''

    const key = type + 'Uids' as 'studentUids' | 'teacherUids'
    if(! this.theClass[key]){
      this.theClass[key] = []
    }

    if(this.theClass[key] && this.theClass[key]?.includes(theUid)){
      delete this.theClass.memberMeta[theUid]
      this.theClass[key] = this.theClass[key]?.filter((uid) => {
        return uid !== theUid
      })
    }else{
      this.theClass[key]?.push(theUid)
    }

    this.theClass.memberUids = this.theClass.teacherUids?.concat(this.theClass.studentUids || [])

    if(typeof user === 'object'){
      this.theClass.memberMeta[theUid] = {
        ref: this.$getUserPublicProfileDocRef(theUid),
        displayName: user.displayName || '',
        lastName: user.lastName || '',
        firestName: user.firstName || '',
        lastNameYomigana: user.lastNameYomigana || '',
        firestNameYomigana: user.firstNameYomigana || ''
      }
    }
  }

  created(){
    console.trace('created')
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
